import { render, staticRenderFns } from "./VideoTestimonials.vue?vue&type=template&id=4fc3d01b&scoped=true"
import script from "./VideoTestimonials.vue?vue&type=script&lang=js"
export * from "./VideoTestimonials.vue?vue&type=script&lang=js"
import style0 from "./VideoTestimonials.vue?vue&type=style&index=0&id=4fc3d01b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc3d01b",
  null
  
)

export default component.exports